import { Flex } from "antd";
import { FormattedMessage } from "react-intl";

type Props = {
  from?: string;
  to?: string;
  intlKey?: string;
};

export const DateRangeFilterLabel = ({ from, to, intlKey }: Props) => {
  if (!from && !to) return null;

  return (
    <Flex gap={12} align="center" justify="space-between">
      <FormattedMessage id={intlKey || "data.table.filters.dateRange"} />:
      <Flex gap={8} align="center">
        {from && to ? `${from} - ${to}` : from || to}
      </Flex>
    </Flex>
  );
};
